<template>
  <div class="dimmed" v-if="isShow">
    <dl :class="isSmall ? 'small' : ''">
      <dt>{{ title }}</dt>
      <dd>
        <slot></slot>
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'Dimmed',
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: `使用中のサービスではありません。`
    },
    isSmall: {
      type: Boolean,
      default: false,
      required: false
    }
  }
}
</script>

<style lang="scss">
.dimmed {
  position: absolute;
  top:0;
  left:0;
  z-index: 1;
  width:100%;
  height: 100%;
  background-color: rgba(252, 252, 252, 0.7);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  dl {
    padding: {
      top: 20px;
      bottom: 20px;
      left: 20px;
      right: 20px;
    }
    min-height: 70px;
    display:inline-block;
    text-align: center;
    border: 1px solid #E8E8E8;
    box-shadow: 0px 0px 4px rgba(168, 168, 168, 0.25);
    border-radius: 5px;
    background-color:#fff;
    &.small {
      max-width: 270px;
    }
    dt {
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      color: #ff8c8c;
    }
    dd {
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      color: #414141;
      display:inline-block;
      text-align: center;
    }
  }

  .dimmed-menu-text {
    color: #919191;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dimmed.vue